if (!customElements.get('lmp-mobile-purchase')) {
  customElements.define(
    'lmp-mobile-purchase',
    class LmpMobilePurchase extends HTMLElement {
      connectedCallback() {
        this.mobileButton = this.querySelector('[data-lmp-mobile-add]');
        this.productInfo = this.closest('product-info');

        if (!this.mobileButton || !this.productInfo) return;

        this.mobileButton.addEventListener('click', () => {
          const mainButton = this.productInfo.querySelector('.product-form__submit');
          if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
          mainButton.click();
        });

        this.syncButtonState();
        this.observer = new MutationObserver(() => this.syncButtonState());
        this.observer.observe(this.productInfo, {
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          characterData: true,
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      syncButtonState() {
        const mainButton = this.productInfo?.querySelector('.product-form__submit');
        if (!mainButton) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        if (this.mobileButton.disabled !== disabled) this.mobileButton.disabled = disabled;
        const label = mainButton.querySelector('span')?.textContent?.trim();
        if (label && this.mobileButton.textContent.trim() !== label) this.mobileButton.textContent = label;
      }
    }
  );
}
